import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { CompanyAccountCreditRatingBasic } from '@mews-commander/legacy-data-structures';
import { EnumifySelectField } from '@mews-commander/legacy-form';

const creditRatingProps = {
    name: 'creditRatingBasic',
    label: <LocalizedText textKey={TextKey.CreditRatings} />,
    enumClass: CompanyAccountCreditRatingBasic,
    useNameAsValue: true,
    disabled: true,
    showEmptyValue: true,
};

const CreditRatingField = () => <EnumifySelectField {...creditRatingProps} />;

export default CreditRatingField;
